<template>
  <div
    class="c-outages-results"
    :class="{ 'c-outages-results--list-view': outagePageView === 'list' }"
  >
    <template v-if="filterOption !== 'lv'">
      <component
        v-for="outage in getAllFilteredOutages"
        :key="outage.type + outage.id"
        :outage="outage"
        :is="
          outage.type == 'planned'
            ? 'planned-outage-result'
            : 'unplanned-outage-result'
        "
      />
      <div
        v-if="getAllFilteredOutages.length === 0"
        class="c-outages-results__no-outages"
      >
        <div class="c-outages-results__no-outages-inner">
          <h3 class="c-outages-results__no-outages-title">
            {{ noOutagesText() }}
          </h3>
          <p class="c-outages-results__no-outages-text">
            Are you without power?
          </p>
          <a
            v-if="cmsContent.noOutagesFoundLink"
            :href="cmsContent.noOutagesFoundLink"
            class="c-outages-results__no-outages-button readmore readmore__linkBox readmore__linkBox--orange"
          >
            <p>{{ cmsContent.noOutagesFoundText }}</p>
            <span></span>
          </a>
        </div>
      </div>

      <component
        v-if="
          getAllFilteredOutages.length === 0 && cmsContent.noOutagesFeaturePanel
        "
        :is="cmsContent.noOutagesFeaturePanel.Link ? 'a' : 'span'"
        :href="cmsContent.noOutagesFeaturePanel.Link || ''"
      >
        <img
          :src="cmsContent.noOutagesFeaturePanel.Image"
          class="c-outages-results__feature-panel-image"
        />
      </component>
    </template>
    <template v-if="filterOption === 'lv'">
      <lv-outage-result
        v-for="lvOutage in getFilteredLVOutagesGeoJson"
        :key="lvOutage.properties.csvSuburbID"
        :lv-outage="lvOutage"
      />
      <div
        v-if="getFilteredLVOutagesGeoJson.length === 0"
        class="c-outages-results__no-outages"
      >
        <div class="c-outages-results__no-outages-inner">
          <h3 class="c-outages-results__no-outages-title">
            There are currently no individual outages by suburb
          </h3>
          <p class="c-outages-results__no-outages-text">
            Are you without power?
          </p>
          <a
            v-if="cmsContent.noOutagesFoundLink"
            :href="cmsContent.noOutagesFoundLink"
            class="c-outages-results__no-outages-button readmore readmore__linkBox readmore__linkBox--orange"
          >
            <p>{{ cmsContent.noOutagesFoundText }}</p>
            <span></span>
          </a>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { mapGetters } from "vuex";

import PlannedOutageResult from "./PlannedOutageResult.vue";
import UnplannedOutageResult from "./UnplannedOutageResult.vue";
import LvOutageResult from "./LvOutageResult.vue";

export default {
  created() {},
  components: {
    PlannedOutageResult,
    UnplannedOutageResult,
    LvOutageResult,
  },
  mounted() {},
  computed: {
    ...mapFields([
      "outagePageView",
      "searchText",
      "filterMarkerSelectedLocation",
      "filterOption",
      "cmsContent",
    ]),
    ...mapGetters(["getAllFilteredOutages", "getFilteredLVOutagesGeoJson"]),
  },
  methods: {
    noOutagesText() {
      if (this.searchText != "" || this.filterMarkerSelectedLocation != null)
        return "No outages found for this search";
      if (this.filterOption === "current")
        return "There are currently no known outages";
      if (this.filterOption === "recent")
        return "There are currently no recent outages";
      if (this.filterOption === "scheduled")
        return "There are currently no scheduled outages";
      return "";
    },
  },
};
</script>

<style lang="scss"></style>
